<template>
  <div>
    <div v-if="isOpen">
      <Content
        v-for="content of contents"
        :key="content.id"
        :title="content.title"
        :image-url="content.imageUrl"
        :status="content.status"
        :incomplete-activities="content.incompleteActivities"
        :tenant-url="tenantUrl"
        :parent-group-id="parentGroupId"
        :team-ids="content.teamIds"
        :content-id="
          content.moduleId || content.guideId || content.scormContentId
        "
        :content-type="content.contentType"
        additional-style="middle"
        :is-desktop="isDesktop"
        :due-date="content.dueDate"
      />
    </div>
    <div
      class="edume-content edume-show-more edume-toggle edume-link"
      @click="toggle"
    >
      {{ isOpen ? dropdownCloseMessage : dropdownOpenMessage }}
      <Chevron v-if="isOpen" class="edume-chevron" orientation="edume-down" />
      <Chevron v-else class="edume-chevron" />
    </div>
  </div>
</template>

<script>
import Content from './Content.vue';
import Chevron from './svg/Chevron.vue';
import {polyglot} from '../utils/polyglot';

export default {
  components: {
    Content,
    Chevron,
  },
  props: {
    contents: {
      type: Array,
      required: true,
    },
    tenantUrl: {
      type: String,
      required: true,
    },
    parentGroupId: {
      type: Number,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    dropdownOpenMessage() {
      const count = this.contents.length;
      return polyglot.t('Courses.dropdownOpenMessage', {count: count});
    },
    dropdownCloseMessage() {
      return polyglot.t('Courses.dropdownCloseMessage');
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style>
.edume-show-more {
  height: max-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  box-shadow:
    0px 1px 2px rgba(32, 32, 33, 0.06),
    0px 2px 8px rgba(32, 32, 33, 0.1);
  border-radius: 0 0 4px 4px;
}

.edume-toggle {
  font-weight: bold;
}

.edume-chevron {
  margin-left: 8px;
}

.edume-link {
  color: #005c7f !important;
}
.edume-link:hover {
  color: #339cbd !important;
}
.edume-link:hover > .edume-chevron svg path {
  fill: #339cbd !important;
}
</style>
